import React from "react";
import LinkHeader from "@dimensions/link/components/HeaderLink";
import { SkeletonBase } from "@foris/avocado-suite";
import { Link } from "@models/ISchema";
import styles from "../FormEdit/formEdit.module.scss";

const EditSessionSkeleton = () => {
  return (
    <div className={styles.main}>
      <LinkHeader link={{} as Link} isLoading />
      <SkeletonBase width="100%" height={52} radius={0} />

      <div className={styles.content}>
        <div>
          <div className={styles.sectionSkeleton}>
            <SkeletonBase
              className={styles.sectionSkeleton_header}
              width="100%"
              height={48}
              radius="8px 8px 0 0"
            />
            <div className={styles.sectionSkeleton_content}>
              <SkeletonBase
                className={styles.sectionSkeleton_session}
                width="100%"
                height={60}
                radius={8}
              />
              <SkeletonBase
                className={styles.sectionSkeleton_session}
                width="100%"
                height={60}
                radius={8}
              />
              <SkeletonBase
                className={styles.sectionSkeleton_footer}
                width="100%"
                height={28}
                radius={8}
              />
            </div>
          </div>
        </div>

        <div className={styles.formSkeleton}>
          <div className={styles.formSkeleton_header}>
            <SkeletonBase width={180} height={24} />
            <SkeletonBase width={275} height={18} />
          </div>

          <div className={styles.formSkeleton_content}>
            {Array.from({ length: 5 }).map((_, index) => (
              <div className={styles.formBoxSkeleton} key={index}>
                <div className={styles.formBoxSkeleton_header}>
                  <SkeletonBase width={60} height={18} />
                  <SkeletonBase width={80} height={28} />
                </div>

                <div className={styles.formBoxSkeleton_content}>
                  <SkeletonBase width="100%" height={32} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSessionSkeleton;
